<i18n src="./resources/locales.json"></i18n>
<template>
  <v-container class="pa-4 light-surface">
    <v-textarea
      ref="input"
      v-model="message"
      class="conversation-input-field"
      id="interaction-input"
      :auto-grow="false"
      :clearable="false"
      color="custom-primary"
      :flat="false"
      no-resize
      :rows="1"
      :placeholder="$t('writeMessage')"
      :hide-details="true"
    >
      <v-icon slot="append" v-ripple class="send-btn mr-2">mdi-send</v-icon>
    </v-textarea>
  </v-container>
</template>

<script>
export default {
  name: 'EcsCustomerChatFooter',
  data() {
    return {
      message: ''
    };
  }
};
</script>

<style scoped>
.conversation-input-field {
  border-radius: 8px;
  padding: 0;
  background-color: var(--v-custom-surface-base);
  transition: border-radius 0.2s ease;
}
</style>
<style>
.conversation-input-field.v-text-field.theme--dark .v-input__slot {
  background: var(--v-custom-surface-lighten1) !important;
}
.conversation-input-field.v-text-field.theme--light .v-input__slot {
  background: var(--v-custom-surface-darken1) !important;
}
.conversation-input-field .v-input__slot {
  margin: 0;
}
.conversation-input-field .v-input__control .v-input__slot .v-input__append-inner {
  margin: auto;
}
.conversation-input-field.v-input--is-focused {
  border-radius: 8px 8px 0 0 !important;
}
.conversation-input-field .v-text-field__details {
  display: none;
}
.conversation-input-field.v-text-field > .v-input__control > .v-input__slot:before {
  border: none !important;
}
.conversation-input-field .theme--light.v-text-field .v-input__control .v-input__slot:before {
  border-color: transparent !important;
}
.conversation-input-field > div {
  transition: box-shadow 0.3s linear;
}
.conversation-input-field.multiple-lines > div {
  box-shadow: 0 0 20px #000a;
}
.conversation-input-field .v-text-field {
  border-radius: 8px;
  padding: 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  margin: 0;
}
.conversation-input-field .v-text-field {
  margin: 0 0 4px 0;
}
.conversation-input-field textarea::-webkit-scrollbar {
  width: 0;
}
#interaction-input {
  margin: 8px 8px 0 8px !important;
}
</style>
